import React, { useEffect, useState, useCallback } from 'react'
import PropTypes from "prop-types";
import { Table, Icon, Button, Header, Segment } from 'semantic-ui-react'
import { onError } from '../../components/shared/messages'
import { GetFolios } from '../../api/services/finance'
import { useTextResources } from '../../language';
import { EntityTypes } from '../../components/shared/constants';
import { Currencies } from '../../components/shared/currencies';
const FolioList = ({ ReservationID, HotelID, Currency, onSelect }) => {
    const text = useTextResources()
    const [folios, setFolios] = useState([])
    const [selected, setSelected] = useState()
    const [showPlaceholder, setShowPlaceholder] = useState(false)

    useEffect(()=>{
        if (onSelect) {
            onSelect(folios.find(folio=>folio.Id === selected))
        }
    }, [selected])
    useEffect(() => {
        if (ReservationID) {
            (async () => {
                try {
                    const folios = await GetFolios({
                        HotelID,
                        EntityIDs: [ReservationID],
                        EntityTypeIDs: [1],
                        IncludeOwner: true,
                        IncludeFolioEntities: true,
                        IncludeTotalAmount: true,
                        IncludeTransactions: true,
                        IncludeTransferedOutTransactions: true,
                        Currency
                    })
                    setFolios(folios)
                    if (folios.length) {
                        setSelected(folios[0].Id)
                    } else {
                        setShowPlaceholder(true)
                    }
                } catch (error) {
                    onError(error)
                }
            })()
        }
    }, [ReservationID, Currency])

    const price = useCallback(value => {
        const c = Currencies[Currency]
        return `${value.toFixed(2)} ${c ? c.symbol : ''}`
    }, [])

    return showPlaceholder ? <Segment placeholder>
        <Header icon>
            <Icon name='dont' />
        No folios where found for this reservation
        </Header>
        <Button positive>Create New Folio</Button>
    </Segment> :
        <Table selectable className="FolioList">
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>{text("Folio")}</Table.HeaderCell>
                    <Table.HeaderCell>{text("FolioOwner")}</Table.HeaderCell>
                    <Table.HeaderCell>{text("ReRoute")}</Table.HeaderCell>
                    <Table.HeaderCell>{text("AccountType")}</Table.HeaderCell>
                    <Table.HeaderCell>{text("NetCharges")}</Table.HeaderCell>
                    <Table.HeaderCell>{text("Tax")}</Table.HeaderCell>
                    <Table.HeaderCell>{text("Total")}</Table.HeaderCell>
                    <Table.HeaderCell>{text("Payments")}</Table.HeaderCell>
                    <Table.HeaderCell>{text("OpenBalance")}</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {
                    folios.map(folio => {
                        return <Table.Row positive={selected && selected == folio.Id} key={folio.Id} onClick={() => setSelected(folio.Id)}>
                            <Table.Cell>{folio.Id}</Table.Cell>
                            <Table.Cell>{folio.Owner.Name}</Table.Cell>
                            <Table.Cell>{/* Reroute */}</Table.Cell>
                            <Table.Cell>{text(EntityTypes[folio.Owner.EntityTypeId])}</Table.Cell>
                            <Table.Cell>{price(folio.TotalTaxNotExempt)}</Table.Cell>
                            <Table.Cell>{price(folio.TotalPayments)}</Table.Cell>
                            <Table.Cell>{price(folio.TotalChargesAfterTax)}</Table.Cell>
                            <Table.Cell>{price(folio.TotalPayments)}</Table.Cell>
                            <Table.Cell>{price(folio.RestPayment)}</Table.Cell>
                        </Table.Row>
                    })
                }
            </Table.Body>
        </Table>
}
FolioList.propTypes = {
    ReservationID: PropTypes.number,
    HotelID: PropTypes.number,
    Currency: PropTypes.number,
    onSelect: PropTypes.func
}
export default FolioList